import React from 'react';
import ArcText from '@src/core/ui/arc-text';
import ArcStack from '@src/core/ui/arc-stack';
import ArcIconButton from '@src/core/ui/arc-icon-button';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { ArcToolbarProps } from './types';


const ArcToolbar: React.FC<ArcToolbarProps> = (props) => {
  const { title, goBack, titleFontSize } = props;

  return (
    <ArcStack spacing={1} direction='row' alignItems='center'>
      <ArcIconButton size='small' onClick={goBack}>
        <ArrowBackIcon />
      </ArcIconButton>
      <ArcText.h4 fontSize={titleFontSize}>{title}</ArcText.h4>
    </ArcStack>
  );
};

export default ArcToolbar;